export default "__VITE_ASSET__2306ffe2__"